import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { useKioskPro } from 'src/hooks/use-kiosk-pro';
import useUI from 'src/hooks/use-ui';

// TODO: We are allowing Kiosk Pro customers to login to their account.
// User account UI for Kiosk Pro will be implemented in a future PR.
export const useIsAccountEnabled = (): boolean => {
  const UI = useUI();
  const { dispensary } = useDispensary();
  const isKioskProEnabled = useKioskPro();
  return (!UI.isKiosk && !dispensary?.featureFlags.hideMyAccount) || isKioskProEnabled;
};
